import { render, staticRenderFns } from "./Detailedprofile.vue?vue&type=template&id=7fc23bac"
import script from "./Detailedprofile.vue?vue&type=script&lang=js"
export * from "./Detailedprofile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports